import React, { memo, forwardRef } from "react";
const SvgCapitalZeta = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M20.832 24.992H10.44c-.544 0-.92-.136-1.128-.408A1.4 1.4 0 019 23.72c0-.368.216-.84.648-1.416l9.12-12.216h-8.4c-.432 0-.736-.112-.912-.336-.176-.224-.264-.456-.264-.696 0-.24.088-.472.264-.696.176-.24.48-.36.912-.36h10.104c.512 0 .872.136 1.08.408a1.4 1.4 0 01.312.864c0 .368-.2.816-.6 1.344L12.072 22.88h8.76c.432 0 .736.12.912.36.176.224.264.456.264.696 0 .24-.088.48-.264.72-.176.224-.48.336-.912.336z"
      />
    </svg>
  );
});
SvgCapitalZeta.displayName = "SvgCapitalZeta";
const MemoForwardRef = memo(SvgCapitalZeta);
export default MemoForwardRef;
